module.exports = __webpack_public_path__ + "static/laptop-655210120a35483346bb327eadde5045.jpg";